var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal align-items-center justify-content-center",
        class: { "d-flex": _vm.showModal === true },
        attrs: { tabindex: "-1" },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title" }, [
                _vm._v(_vm._s(_vm._f("trans")("No File Found"))),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button", "aria-label": "Close" },
                  on: {
                    click: function ($event) {
                      return _vm.submit("auto")
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("×"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("p", [_vm._v(_vm._s(_vm._f("trans")(_vm.bodyText)))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "modal-footer justify-content-between align-items-end",
              },
              [
                _c("div", { staticClass: "d-flex flex-column" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.submit("auto")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fa fa-times" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("trans")("Close")) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-items-stretch flex-column" },
                  _vm._l(_vm.buttons, function (button, idx) {
                    return _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        class: { "m-t-5": idx > 0 },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.submit(button.downloadEngine)
                          },
                        },
                      },
                      [
                        _c("i", { class: button.icon }),
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("trans")(button.text)) +
                            "\n                        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.showModal
      ? _c("div", { staticClass: "modal-backdrop fade show" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }